var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDotMessage = function SvgIconDotMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    overflow: "visible"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.564
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.418 15.977a2.564 2.564 0 0 1-2.564 2.564H6.473l-5.128 5.127V3.159A2.564 2.564 0 0 1 3.91.595h17.945a2.564 2.564 0 0 1 2.564 2.564zM14.163 7.005h-7.69M19.29 12.132H6.472"
  }))));
};
export default SvgIconDotMessage;